import { useTraduccion } from '@tallerya/i18n';
import { IconoSol, IconoSoporte, IconoWifi } from '@tallerya/ui';
import { useSyncExternalStore } from 'react';

// La barra derecha del admin: «Barra lateral» del Figma, 61 px con tres íconos.
//
// **Solo la conexión dice algo de verdad hoy.** Soporte y tema no tienen a dónde
// llevar todavía —no hay canal de soporte ni modo oscuro (ver tokens.css)— y
// se dibujan como íconos quietos, no como botones que no hacen nada. Lo que
// hace cada uno lo decide #100.

function suscribir(avisar: () => void) {
  window.addEventListener('online', avisar);
  window.addEventListener('offline', avisar);
  return () => {
    window.removeEventListener('online', avisar);
    window.removeEventListener('offline', avisar);
  };
}

function useEnLinea(): boolean {
  return useSyncExternalStore(suscribir, () => navigator.onLine);
}

export function BarraDerecha({ id }: { id: string }) {
  const { t } = useTraduccion();
  const enLinea = useEnLinea();
  const conexion = enLinea ? t('admin.layout.conectado') : t('admin.layout.sinConexion');

  return (
    <aside id={id} className="barra-derecha" aria-label={t('admin.layout.panel')}>
      <span role="img" aria-label={t('admin.layout.soporte')} title={t('admin.layout.soporte')}>
        <IconoSoporte />
      </span>
      <span
        role="img"
        aria-label={conexion}
        title={conexion}
        className={enLinea ? undefined : 'barra-derecha__apagado'}
      >
        <IconoWifi />
      </span>
      <span role="img" aria-label={t('admin.layout.tema')} title={t('admin.layout.tema')}>
        <IconoSol />
      </span>
    </aside>
  );
}
